import request from './adminRequest'

export const translateApi = {
  translateText (data) {
    return request.post('/translate', data)
  },
}
export default translateApi
